module.exports = {
      id: "1-usage",
      viewBox: "0 0 11 18",
      url: __webpack_public_path__ + "assets/img/sprite-8cafc1.svg#1-usage",
      toString: function () {
        return this.url;
      }
    }